import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_ACCOUNT_PASSWORD_MUTATION = gql`
  mutation changePassword(
    $currentPassword: String!
    $newPassword: String!
    $confirmation: String!
  ) {
    changePassword(
      currentPassword: $currentPassword
      newPassword: $newPassword
      confirmation: $confirmation
    )
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateAccountPasswordMutation extends Mutation<RootMutation> {
  document = UPDATE_ACCOUNT_PASSWORD_MUTATION;
}
